import { FALLBACK_PORTFOLIO_THUMBNAIL } from '../types';

/** Local Next `public/` thumbs shipped with the app (Angular used assets/...). */
export function localPortfolioTemplateThumb(
  apiId?: number | null,
  kind?: string | null,
): string {
  const id = Number(apiId);
  if (id === 1) {
    return '/images/portfolio-templates/template-1.png';
  }
  if (id === 2) {
    return '/images/portfolio-templates/template-2.png';
  }
  if (id === 3 || id === 4) {
    return '/images/portfolio-templates/template-3.png';
  }

  const normalized = (kind || '').toLowerCase();
  if (normalized === 'modern' || normalized === 'modern_v2') {
    return '/images/portfolio-templates/template-1.png';
  }
  if (
    normalized === 'architect' ||
    normalized === 'creative' ||
    normalized === 'double_column_v2'
  ) {
    return '/images/portfolio-templates/template-2.png';
  }
  if (
    normalized === 'classic' ||
    normalized === 'classic_v2' ||
    normalized === 'minimal' ||
    normalized === 'minimal_v2'
  ) {
    return '/images/portfolio-templates/template-3.png';
  }

  return FALLBACK_PORTFOLIO_THUMBNAIL;
}

/**
 * Resolve portfolio template sidebar thumbnails for Next.
 *
 * API seed values are bare filenames (`portfolio-template-1.jpg`) that Angular
 * resolved via `<base href="/">` + static assets. Next has no base tag and those
 * JPGs are not in `public/`, so raw `img.src` 404s → blank white cards.
 *
 * Prefer absolute remote URLs when present; otherwise map known API / Angular
 * paths onto `/images/portfolio-templates/template-N.png`.
 */
export function resolvePortfolioTemplateImageUrl(input: {
  /** API template rows are `Record<string, unknown>`; coerce non-strings safely. */
  candidates?: ReadonlyArray<unknown>;
  apiId?: number | null;
  kind?: string | null;
}): string {
  const fallback = localPortfolioTemplateThumb(input.apiId, input.kind);
  const candidates = input.candidates || [];

  for (let i = 0; i < candidates.length; i++) {
    const value = candidates[i];
    if (value == null) {
      continue;
    }
    if (typeof value !== 'string' && typeof value !== 'number') {
      continue;
    }
    const raw = String(value).trim();
    if (!raw) {
      continue;
    }

    if (
      raw.startsWith('http://') ||
      raw.startsWith('https://') ||
      raw.startsWith('//')
    ) {
      return raw.startsWith('//') ? `https:${raw}` : raw;
    }

    if (raw.startsWith('/images/portfolio-templates/')) {
      return raw;
    }

    const localFile = raw.match(
      /(?:^|\/)template-([1-4])\.(?:png|jpe?g|webp)$/i,
    );
    if (localFile) {
      return `/images/portfolio-templates/template-${localFile[1]}.png`;
    }

    const apiFile = raw.match(
      /(?:^|\/)portfolio-template-(\d+)(?:-preview)?\.(?:png|jpe?g|webp)$/i,
    );
    if (apiFile) {
      return localPortfolioTemplateThumb(Number(apiFile[1]), input.kind);
    }
  }

  return fallback;
}
